<script setup lang="ts">
import { cardVariants } from '~/utils/card'

const props = defineProps<{
  title: string
  coverImage?: string
}>()

const coverImageSrc = computed<string | undefined>(() => props.coverImage)
const { coverFallbackImage, shouldRenderCoverImage, handleCoverImageError } = useCoverImageFallback(() => coverImageSrc.value)
const fallbackImageSrc = computed<string | undefined>(() => coverFallbackImage ?? undefined)
</script>

<template>
  <div :class="cardVariants.card.base({ type: 'journal', size: 'large', presentation: true })">
    <div class="w-full bg-carbon-50 rounded-4xl flex items-center justify-center p-2xl overflow-hidden aspect-square">
      <img
        v-if="shouldRenderCoverImage"
        :src="coverImageSrc"
        :alt="title || 'Omslag'"
        :class="cardVariants.image({ type: 'book', size: 'large', presentation: true })"
        @error="handleCoverImageError"
      >
      <img
        v-else
        :src="fallbackImageSrc"
        alt=""
        :class="cardVariants.image({ type: 'book', size: 'large', presentation: true })"
      >
    </div>
  </div>
</template>
